import React from 'react';
import { Redirect } from 'expo-router';

// Outside app/ so Metro's platform route overrides cannot redirect a native
// route's shared import back into that same route.
export default function LegacyOnboardingRedirect() {
  return <Redirect href="/(app)/app" />;
}
